// shared/constants/journeyConfig.js
// Journey-specific styling and configuration

import { Sparkles, Heart, DollarSign, Brain, Smile, Eye } from 'lucide-react';

export const journeyConfig = {
  confidence: {
    icon: Sparkles,
    emoji: '💪',
    color: 'bg-peach-400',
    lightColor: 'bg-peach-50',
    mediumColor: 'bg-peach-100',
    textColor: 'text-peach-700',
    borderColor: 'border-peach-200',
    gradient: 'from-peach-300 to-peach-400',
    hoverGradient: 'from-peach-400 to-peach-500',
    cardGradient: 'from-peach-200 via-cream-200 to-peach-300'
  },
  love: {
    icon: Heart,
    emoji: '❤️',
    color: 'bg-pink-400',
    lightColor: 'bg-pink-50',
    mediumColor: 'bg-pink-100',
    textColor: 'text-pink-700',
    borderColor: 'border-pink-200',
    gradient: 'from-pink-300 to-pink-400',
    hoverGradient: 'from-pink-400 to-pink-500',
    cardGradient: 'from-pink-200 via-peach-200 to-pink-300'
  },
  abundance: {
    icon: DollarSign,
    emoji: '✨',
    color: 'bg-cream-500',
    lightColor: 'bg-cream-50',
    mediumColor: 'bg-cream-100',
    textColor: 'text-brown-700',
    borderColor: 'border-cream-300',
    gradient: 'from-cream-400 to-cream-500',
    hoverGradient: 'from-cream-500 to-cream-600',
    cardGradient: 'from-cream-200 via-peach-100 to-cream-300'
  },
  healing: {
    icon: Brain,
    emoji: '🌙',
    color: 'bg-brown-400',
    lightColor: 'bg-brown-50',
    mediumColor: 'bg-brown-100',
    textColor: 'text-brown-700',
    borderColor: 'border-brown-200',
    gradient: 'from-brown-300 to-brown-400',
    hoverGradient: 'from-brown-400 to-brown-500',
    cardGradient: 'from-brown-200 via-cream-200 to-brown-300'
  },
  gratitude: {
    icon: Smile,
    emoji: '🙏',
    color: 'bg-orange-400',
    lightColor: 'bg-orange-50',
    mediumColor: 'bg-orange-100',
    textColor: 'text-orange-700',
    borderColor: 'border-orange-200',
    gradient: 'from-orange-300 to-orange-400',
    hoverGradient: 'from-orange-400 to-orange-500',
    cardGradient: 'from-orange-200 via-peach-200 to-orange-300'
  },
  focus: {
    icon: Eye,
    emoji: '🎯',
    color: 'bg-peach-500',
    lightColor: 'bg-peach-50',
    mediumColor: 'bg-peach-200',
    textColor: 'text-peach-800',
    borderColor: 'border-peach-300',
    gradient: 'from-peach-400 to-peach-500',
    hoverGradient: 'from-peach-500 to-peach-600',
    cardGradient: 'from-peach-300 via-cream-300 to-peach-400'
  },
  clarity: {
    icon: Sparkles,
    emoji: '💎',
    color: 'bg-cream-400',
    lightColor: 'bg-cream-50',
    mediumColor: 'bg-cream-100',
    textColor: 'text-brown-600',
    borderColor: 'border-cream-200',
    gradient: 'from-cream-300 to-cream-400',
    hoverGradient: 'from-cream-400 to-cream-500',
    cardGradient: 'from-cream-200 via-peach-100 to-cream-300'
  },
  joy: {
    icon: Smile,
    emoji: '☀️',
    color: 'bg-orange-400',
    lightColor: 'bg-orange-50',
    mediumColor: 'bg-orange-100',
    textColor: 'text-orange-700',
    borderColor: 'border-orange-200',
    gradient: 'from-orange-300 to-orange-400',
    hoverGradient: 'from-orange-400 to-orange-500',
    cardGradient: 'from-orange-200 via-cream-200 to-orange-300'
  },
  courage: {
    icon: Sparkles,
    emoji: '🦁',
    color: 'bg-peach-600',
    lightColor: 'bg-peach-50',
    mediumColor: 'bg-peach-100',
    textColor: 'text-peach-800',
    borderColor: 'border-peach-300',
    gradient: 'from-peach-500 to-peach-600',
    hoverGradient: 'from-peach-600 to-peach-700',
    cardGradient: 'from-peach-300 via-orange-200 to-peach-400'
  }
};

// Helper function to get journey config by category/title
export const getJourneyConfig = (categoryOrTitle) => {
  const key = categoryOrTitle?.toLowerCase();
  return journeyConfig[key] || journeyConfig.confidence;
};